/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Container, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { useContext } from 'react';
import { useLoading } from '../../../providers/LoadingProvider';
import { UserContext } from '../../../providers/UserProvider';
import {
  getNewsById,
  update,
  register,
  getAttachments,
  uploadAttachment,
  destroy,
} from '../../../services/news';
import { isBibiUser } from '../../../utils/roles';
import { DropzoneAreaBase } from 'material-ui-dropzone';
import { TextAreaFormChallenge } from '../../../components/FormChallenge/style';
import Checkbox from '@material-ui/core/Checkbox';
import { Editor } from 'react-draft-wysiwyg';
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { useParams, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Attachments } from './attachments';
import Swal from 'sweetalert2';
import api from '../../../services/api';
import { DeleteForever } from '@material-ui/icons';
import Cropper from 'react-easy-crop';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 'inherit',
  },
  container: {
    paddingLeft: 0,
    paddingRight: 0,
    justifyContent: 'center',
  },
  title: {
    fontSize: 36,
    color: '#FFFFFF',
    textTransform: 'uppercase',
    letterSpacing: '-2.05px',
  },
  orangeSet: {
    backgroundColor: '#FE5D00',
    padding: '0rem 0rem 5rem 0rem',
  },
  whiteSet: {
    backgroundColor: '#FFFFFF',
    height: 0,
  },
  mainCards: {
    marginTop: '40px',
  },
  filterDiv: {
    marginTop: '15px !important',
  },
  checkColor: {
    color: `${theme.palette.primary.main}!important`,
  },
  checkDisabled: {
    color: '#C6C6C6!important', // cinza para desabilitado
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  dropzonePreview: {
    height: 130,
    minHeight: 130,
    border: '1px solid #ebebeb',
    background: '#ebebeb',
    boxShadow: '0px 0px 2px #6c6c6c',
    borderRadius: 10,
    minWidth: 130,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    position: 'relative',
    cursor: 'pointer',
    '&:hover $overlay': {
      opacity: 1,
    },
    '&:hover $actions': {
      display: 'flex',
    },
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0,0,0,0.45)',
    opacity: 0,
    borderRadius: 8,
    zIndex: 1,
    pointerEvents: 'none',
    transition: 'opacity 0.3s cubic-bezier(0.4,0,0.2,1)',
  },
  actions: {
    display: 'none',
    flexDirection: 'column',
    gap: '0.5rem',
    position: 'absolute',
    top: 0,
    right: 0,
    marginTop: '0.2rem',
    marginRight: '0.2rem',
    zIndex: 2,
  },
  actionButton: {
    border: 'none',
    height: 30,
    width: 30,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
}));

const SaveButton = styled.button`
  background-color: #fe5d00;
  width: 100%;
  padding: 10px 0;
  border: none;
  border-radius: 8px;
  color: white;
  font-weight: bold;
  cursor: pointer;
  margin-top: 2rem;
`;

const DeleteButton = styled.button`
  background-color: transparent;
  color: #fe5d00;
  border: solid 1px #fe5d00;
  width: 100%;
  padding: 10px 0;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 1rem;
`;

export function RegisterNews() {
  const { userState } = useContext(UserContext);
  const { loading, setLoading } = useLoading();
  const classes = useStyles();
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const [form, setForm] = useState({
    title: '',
    notify: false,
    imagem: '', // url da imagem atual
  });

  const { id } = useParams();
  const history = useHistory();

  const [crop, setCrop] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (!id) return;
    getNewsById(id)
      .then((data) => {
        setLoading(true);
        if (data && data.length > 0) {
          const notice = data[0];
          if (notice.IMAGEM === '/uploads/banner-noticias.png') {
            notice.IMAGEM = '';
          }
          setForm({
            title: notice.TITULO,
            notify: false,
            imagem: notice.IMAGEM || '', // campo da imagem vinda do backend
          });

          if (notice?.CONTEUDO) {
            const blocksFromHTML = convertFromHTML(notice.CONTEUDO);
            const state = ContentState.createFromBlockArray(
              blocksFromHTML.contentBlocks,
              blocksFromHTML.entityMap
            );
            setEditorState(() => EditorState.createWithContent(state));
          } else {
            setEditorState(() => EditorState.createEmpty());
          }
        }
      })
      .finally(() => setLoading(false));

    getAttachments(id).then((data) => {
      setExistingAttachments(
        Array.isArray(data.data)
          ? data.data.map((item) => ({
              url: `https://cxd.bibi.com:3636${item.CAMINHO}`,
              name: item.NOME,
              id: item.ID,
            }))
          : []
      );
    });
  }, [id]);

  function getImage() {
    if (dropzoneImage) {
      return URL.createObjectURL(dropzoneImage);
    } else {
      return `https://cxd.bibi.com:3636${form.imagem}`;
    }
  }

  const [attachmentFiles, setAttachmentFiles] = useState([]);

  const [dropzoneImage, setDropzoneImage] = useState(null);

  function handleAddImage(event) {
    setDropzoneImage(event[0].file);
  }

  function handleAttachmentsChange(files) {
    setAttachmentFiles(files);
  }

  function onEditorStateChange(editorState) {
    setEditorState(editorState);
  }

  async function save() {
    setLoading(true);
    setDeleteLoading(false);
    try {
      let imagemUrl = form.imagem;
      if (dropzoneImage) {
        const config = { headers: { 'Content-Type': 'multipart/form-data' } };
        let img = new FormData();
        img.append('file', dropzoneImage);
        await api.post('utils/upload', img, config).then((response) => {
          imagemUrl = response.data.url;
        });
      }
      if (id) {
        await update(id, {
          TITULO: form.title,
          CONTEUDO: draftToHtml(convertToRaw(editorState.getCurrentContent())),
          IMAGEM: imagemUrl ? imagemUrl : '/uploads/banner-noticias.png',
        });
        for (let i = 0; i < attachmentFiles.length; i++) {
          const item = attachmentFiles[i];
          await uploadAttachment(item.file, item.name, id);
        }
        setLoading(false);
        Swal.fire({
          icon: 'success',
          title: 'Registro atualizado!',
          text: 'A notícia foi atualizada com sucesso.',
          confirmButtonText: 'Ok',
        }).then(() => {
          history.push(`/noticias`);
        });
      } else {
        const { id: responseId } = await register({
          TITULO: form.title,
          CONTEUDO: draftToHtml(convertToRaw(editorState.getCurrentContent())),
          NOTIFICAR: form.notify,
          IMAGEM: imagemUrl ?? '',
        });
        for (let i = 0; i < attachmentFiles.length; i++) {
          const item = attachmentFiles[i];
          await uploadAttachment(item.file, item.name, responseId);
        }
        setLoading(false);
        Swal.fire({
          icon: 'success',
          title: 'Cadastro realizado!',
          text: 'A notícia foi cadastrada com sucesso.',
          confirmButtonText: 'Ok',
        }).then(() => {
          history.push(`/noticias`);
        });
      }
    } catch (e) {
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Ops...',
        text: 'Ocorreu um erro ao cadastrar a notícia. Tente novamente',
        confirmButtonText: 'Ok',
      });
    }
  }

  const [existingAttachments, setExistingAttachments] = useState([]);

  return (
    <div className={classes.root}>
      <Container component="main" className={classes.container}>
        <Box
          className={clsx(`${classes.orangeSet} `, {
            fit: isBibiUser(userState?.tipo),
          })}
          textAlign="center"
        >
          <Box paddingTop={2} textAlign="center" className="header-div">
            <Typography
              className={classes.title}
              component="h1"
              variant="subtitle1"
            >
              Nova notícia
            </Typography>
          </Box>
        </Box>
        <Box className={`header-div mob ${classes.filterDiv}`}>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={12} md={8}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <label className={classes.label}>Título:</label>
              </div>
              <TextAreaFormChallenge
                // maxLength={30}
                value={form.title}
                rows={2}
                onChange={(e) => setForm({ ...form, title: e.target.value })}
              />

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: '-8px',
                  marginTop: '10px',
                  cursor: id ? 'not-allowed' : 'pointer',
                  opacity: id ? 0.6 : 1,
                }}
              >
                <Checkbox
                  disabled={!!id}
                  classes={{
                    root: id ? classes.checkDisabled : classes.checkColor,
                    checked: id ? classes.checkDisabled : classes.checkColor,
                  }}
                  value={form.notify}
                  onChange={(e) =>
                    setForm({ ...form, notify: e.target.checked })
                  }
                />
                <span style={{ marginTop: '4px' }}>Notificar fornecedores</span>
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <label htmlFor="">Capa:</label>
              <div
                className="dropzone-document-container"
                style={{ height: '130px !important' }}
              >
                {!form.imagem && !dropzoneImage ? (
                  <DropzoneAreaBase
                    acceptedFiles={['image/*']}
                    showFileNames
                    dropzoneClass={`dropzone-doc dropzoneImage-doc dropzoneImage-banner-new`}
                    style={{ height: '130px !important' }}
                    dropzoneText={
                      <span
                        style={{
                          fontSize: '.8rem',
                          marginTop: '14px',
                          padding: '0 2rem',
                          textAlign: 'center',
                        }}
                      >
                        Solte a imagem, ou clique aqui para fazer o upload. Se
                        não for adicionada uma imagem, uma padrão será
                        utilizada.
                      </span>
                    }
                    showAlerts={false}
                    filesLimit={1}
                    maxFileSize={1000000000}
                    onAdd={(event) => handleAddImage(event)}
                  />
                ) : (
                  <div className={classes.dropzonePreview}>
                    <div className={classes.actions}>
                      <button
                        className={classes.actionButton}
                        onClick={() => {
                          setDropzoneImage(null);
                          setForm({ ...form, imagem: '' });
                        }}
                      >
                        <DeleteForever
                          htmlColor="#d50000"
                          style={{ height: 20, width: 20 }}
                        />
                      </button>
                    </div>
                    <div className={classes.overlay}></div>
                    <img
                      src={getImage()}
                      alt="Imagem da notícia"
                      style={{ width: '100%', borderRadius: '8px' }}
                    />
                  </div>
                )}

                {dropzoneImage && (
                  <div
                    style={{ position: 'relative', width: '100%', height: 130 }}
                  >
                    <Cropper
                      image={URL.createObjectURL(dropzoneImage)}
                      crop={crop}
                      // zoom={zoom}
                      aspect={undefined} // <-- IMPORTANTE
                      onCropChange={setCrop}
                      // onZoomChange={setZoom}
                      objectFit="cover" // <-- CRUCIAL
                    />
                  </div>
                )}

                {/* {state?.CAMINHO_ARQUIVO && (
                                  <PreviewFile path={state?.CAMINHO_ARQUIVO} />
                                )}
              
                                {state?.CAMINHO_ARQUIVO && (
                                  <RemoveFile onClick={handleDeleteImage} />
                                )} */}
              </div>
            </Grid>
            <Grid item xs={12}>
              <label htmlFor="">Conteúdo:</label>
              <Editor
                localization={{
                  locale: 'pt',
                }}
                toolbar={{
                  options: [
                    'inline',
                    'blockType',
                    'fontSize',
                    'fontFamily',
                    'list',
                    'textAlign',
                    'colorPicker',
                    'link',
                    'embedded',
                    'image',
                    'remove',
                    'history',
                  ],
                }}
                toolbarStyle={{
                  border: 'none',
                }}
                editorStyle={{
                  padding: '0.5em 1em',
                  fontWeight: 'normal',
                }}
                wrapperStyle={{
                  borderRadius: '5px',
                  border: '1px solid #C6C6C6',
                  minHeight: '350px',
                  maxHeight: '400px',
                  overflowY: 'scroll',
                }}
                editorState={editorState}
                onEditorStateChange={onEditorStateChange}
              />
            </Grid>

            <Grid item xs={12}>
              <Attachments
                onFilesChange={handleAttachmentsChange}
                existingFiles={existingAttachments}
                newsId={id}
              />
            </Grid>

            <Grid item xs={12}>
              <SaveButton
                style={{
                  opacity: loading || deleteLoading ? 0.5 : 1,
                  cursor: loading || deleteLoading ? 'not-allowed' : 'pointer',
                }}
                disabled={loading || deleteLoading}
                onClick={save}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </SaveButton>

              {id && (
                <DeleteButton
                  style={{
                    opacity: loading || deleteLoading ? 0.5 : 1,
                    cursor:
                      loading || deleteLoading ? 'not-allowed' : 'pointer',
                  }}
                  disabled={loading || deleteLoading}
                  onClick={async () => {
                    setDeleteLoading(true);
                    setLoading(false);
                    try {
                      for (const item of existingAttachments) {
                        await api.delete(`noticias/${id}/anexos?id=${item.id}`);
                      }
                      await destroy(id);
                      history.push('/noticias');
                    } catch (e) {
                      setDeleteLoading(false);
                    }
                  }}
                >
                  {deleteLoading ? 'Apagando...' : 'Apagar'}
                </DeleteButton>
              )}
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
}
